import { SVGProps } from "react";

export default function CaEnglishTest(props: SVGProps<never>) {
  return (
    <svg
      width={44}
      height={44}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 26s3 4 8 4 8-4 8-4m2-9.52c-.79.97-1.87 1.52-3 1.52s-2.18-.55-3-1.52m-8 0c-.79.97-1.87 1.52-3 1.52s-2.18-.55-3-1.52M42 22c0 11.046-8.954 20-20 20S2 33.046 2 22 10.954 2 22 2s20 8.954 20 20z"
        stroke="#8065C9"
        strokeWidth={3.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
